<template>
    <div class="examinationSidebar">
        <div class="block">
            <router-link to="/enroll/statement">
                <img src="../../assets/images/public/zaixianbaoming.jpg">
            </router-link>
        </div>
        <div class="block">
            <p @click="seeTicket">
                <img src="../../assets/images/public/chaxun.jpg">
            </p>
        </div>
        <div class="block">
            <p @click="seeCJ">
                <img src="../../assets/images/public/chengjichaxun.jpg">
            </p>
        </div>
        <div class="block">
            <p @click="gomyse()" >
                <img src="../../assets/images/public/zairenzheng.jpg">
            </p>
        </div>
        <div class="block">
            <router-link to="/center/questionsAnswers">
                <img src="../../assets/images/public/zaixianwenda.jpg">
            </router-link>
        </div>
        <div class="block">
            <router-link to="/referenceMaterial">
                <img src="../../assets/images/public/chankaozhiliao.png">
            </router-link>
        </div>
        <ticket v-model="ticketShow" :bmInfo="bmInfo"/>
    </div> 
</template>

<script>
import { enrollInfoRecertEnroll, ExamUselistScorePage } from '@/api/center'
import { EnrollInfoListPage, examDetail } from '@/api/enroll'
import ticket from '@/components/ticket'
export default {
    name: "examinationSidebar",
    components: {
        ticket
    },
    data() {
        return{
            ticketShow: false,
            bmInfo: {},
        }
    },
    props:{
        
    },
    methods:{
        seeTicket(){
            if(this.isLogin()){
                EnrollInfoListPage({
                    userId: this.$store.getters.userInfo.id,
                    pageNum: 1,
                    pageSize: 1,
                    isSelf: 1
                }).then(res=>{
                    if(res.total){
                        if(res.list[0].pass == 1 && res.list[0].confirm == 2){
							examDetail({ tbInfoUserId: res.list[0].id }).then(res=>{
							    if(res.examUser.permitNum){
							        this.bmInfo = res.enrollInfo
							        this.examUserId = res.examUser.id
							        this.bmInfo.examRoomNo = res.examRoom.examRoomNo.toString().length==1?'0'+res.examRoom.examRoomNo:res.examRoom.examRoomNo
                                    this.bmInfo.examRoomNo = res.examRoom.province+this.bmInfo.examRoomNo
							        this.bmInfo.level = this.$filters.testfilters(res.enrollInfo.examType)
							        this.bmInfo.addr = res.examRoom.province + res.examRoom.city + res.examRoom.region + '' + res.examRoom.address
							        if(res.enrollCompanys.length){
							            this.bmInfo.gzorby = res.enrollCompanys[0].companyName
							        }else if(res.enrollstu){
							            this.bmInfo.gzorby = res.enrollstu.universityName
							        }
							        this.bmInfo.examTime = this.$filters.dateTime(res.exam.examTime, 'yyyy年MM月dd日 ') + res.exam.examHourStart + '' + res.exam.examHourEnd
							        // this.bmInfo.examTime = this.$filters.dateTime(res.exam.examHourStart, 'yyyy年MM月dd日，hh:mm') + '-' + this.$filters.dateTime(res.exam.examHourEnd, 'hh:mm')
							        this.bmInfo.permitNum = res.examUser.permitNum
							        this.ticketShow = true
							    }else{
							        this.$message.error('当前考试暂无准考证，如查看其他考试请去个人中心')
							    }
							})
                        }else{
                            this.$message.error('当前考试暂无准考证，如查看其他考试请去个人中心')
                        }
                    }else{
                        this.$message.error('暂无考试')
                    }
                })
            }
        },
        gomyse(){
        	enrollInfoRecertEnroll({}).then(res => {
        		this.$router.push({
        		    path: '/center/InformationValidation',
        		    query: {
        		        id:res.certId,
						ids:res.enrollId
        		    }
        		})
        	})
        },
        seeCJ(){
            ExamUselistScorePage({
                pageNum: 1,
                pageSize: 1,
                isChange:1,
                userId:this.$store.getters.userInfo.id,
            }).then(res => {
                if(res.total){
                    let a = res.list[0]
                    if(a.resultType == 2 || a.resultType == 3){
                        this.$router.push('/gradeDetails/' + a.id)
                    }else{
                        this.$message.error('当前考试暂无成绩，如查看其他考试请去个人中心')
                    }
                }else{
                    this.$message.error('暂无考试')
                }
            })
        },
        isLogin(){
            if(this.$store.getters.userInfo.id){
                return true
            }else{
                this.$message({
                    message: '未登录，请前去登录',
                    type: 'error',
                    duration: 1 * 1000
                })
                setTimeout(() => {
                    this.$router.push('/login')
                },1000)
            }
        }
    }
}
</script>

<style scoped>
.examinationSidebar{
    width: 220px;
    margin-right: 20px;
    margin-top: 13px;
}
.block{
    margin-bottom: 10px;
}
.block p{
	cursor: pointer;
}
</style>